import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getAcctStatus } from "./common/service";

export function accountStatusLoader() {
  return defer({
    coreData: resolveLoaderResult(getAcctStatus()),
  });
}
